import { render, staticRenderFns } from "./ItemCarousel.vue?vue&type=template&id=91e2db9c&scoped=true&"
import script from "./ItemCarousel.vue?vue&type=script&lang=js&"
export * from "./ItemCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ItemCarousel.vue?vue&type=style&index=0&id=91e2db9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e2db9c",
  null
  
)

export default component.exports